export default ['Paraben', 'Colorants', 'Huile de palme']
